module.exports = __webpack_public_path__ + "h5/img/icon_yj.3c252ff0.png";